import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import 'common/css/master.css';


import { getStudentGeneralInfoSvc, saveStudentGeneralInfoSvc } from "./parentAssessmentSvc";

const ParentDtls = (props) => {
    const { setLoader, setOpacity, schoolId, acdYrId, studentId, clsId } = props;

    const [fatherName, setFatherName] = useState("");
    const [fatherId, setFatherId] = useState(0);
    const [fatherEducation, setFatherEducation] = useState("");
    const [fatherOccupation, setFatherOccupation] = useState("");
    const [motherId, setMotherId] = useState(0);
    const [motherName, setMotherName] = useState("");
    const [motherEducation, setMotherEducation] = useState("");
    const [motherOccupation, setMotherOccupation] = useState("");
    const [siblingCount, setSiblingCount] = useState(0);
    const [siblingsAge, setSiblingsAge] = useState("");
    const [imgFile, setImgFile] = useState(window.appURL + "/no-image.png");
    const [motherTongue, setMotherTongue] = useState("");
    const [imageBasePath, setImageBasePath] = useState(null);
    const imageService = "https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=";


    useEffect(() => {
        // console.log("ParentDtls called");
        if (schoolId && acdYrId && studentId && clsId)
            getStudentGeneralInfo(schoolId, acdYrId, studentId, clsId);
    }, [schoolId, acdYrId, studentId, clsId]);


    const getStudentGeneralInfo = (schoolId, acdYrId, studentId, clsId) => {
        // console.log("getStudentGeneralInfo called");
        setLoader("block");
        setOpacity(0.5);
        getStudentGeneralInfoSvc(schoolId, acdYrId, studentId, clsId, studentGeneralInfoResponse);
    }

    const studentGeneralInfoResponse = (data) => {
        // console.log("studentGeneralInfoResponse called, data", data);
        if (data.status === "Success") {
            let basePath = data.basePath;
            let photoName = data.generalInfo.familyPhoto;
            setImageBasePath(basePath);
            setFatherId(data.generalInfo.fatherId);
            setFatherName(data.generalInfo.father);
            setFatherEducation(data.generalInfo.fatherEducation);
            setFatherOccupation(data.generalInfo.fatherOccupation);
            setMotherId(data.generalInfo.motherId);
            setMotherName(data.generalInfo.mother);
            setMotherEducation(data.generalInfo.motherEducation);
            setMotherOccupation(data.generalInfo.motherOccupation);
            setSiblingCount(data.generalInfo.siblingCount);
            setSiblingsAge(data.generalInfo.siblingAge);
            setMotherTongue(data.generalInfo.motherTongue);
            if(photoName){
                let imageFileFullPath = imageService+ basePath + "/"  + photoName;
                // console.log("imageFileFullPath", imageFileFullPath);
                setImgFile(imageFileFullPath);
            } else {
                setImgFile(window.appURL + "/no-image.png");
            }
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }




    const saveStudentDetails = () => {
        // console.log("saveStudentDetails called");
        const generalInfoObj = {
            fatherId,
            fatherEducation,
            fatherOccupation,
            motherId,
            motherEducation,
            motherOccupation,
            siblingCount,
            "siblingAge": siblingsAge,
            motherTongue
        }
        // console.log("generalInfoObj", generalInfoObj);

        fetch(imgFile)
            .then(response => response.blob())
            .then(blob => {
                const file = new File([blob], imgFile.split('/').pop(), { type: blob.type });
                setLoader("block");
                setOpacity(0.5);
                saveStudentGeneralInfoSvc(schoolId, acdYrId, studentId, clsId, generalInfoObj, file, saveStudentGeneralInfoResponse);
            })
            .catch(error => {
                console.error("Error fetching the image:", error);
            });

        // saveStudentGeneralInfoSvc(schoolId, acdYrId, studentId, clsId, generalInfoObj, imgFile, saveStudentGeneralInfoResponse);
    }


    const saveStudentGeneralInfoResponse = (data) => {
        // console.log("saveStudentGeneralInfoResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const handlePhotoChange = (e) => {
        // console.log("handlePhotoChange called");
        if (e.target.files && e.target.files[0]) {
            setImgFile(URL.createObjectURL(e.target.files[0]));
        }
    };

    const handlePhotoClick = () => {
        // console.log("handlePhotoClick called");
        document.getElementById("img_photoId").click();
    };

    const onError = () => {
        // console.log("onError called in photo");
        setImgFile(window.appURL + "/no-image.png");
    };


    return (
        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" style={{ border: "1px solid #ccc", borderRadius: "10px" }}>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 pull-right padding-remove"
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "100%", marginTop: "20px" }}>
                    <div className="col-md-4 col-sm-4 col-xs-4 padding-remove" >
                        <label className="control-label text-right col-md-12 col-sm-12 col-xs-12 " htmlFor="name">
                            Family Photo
                        </label>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6 padding-remove"
                        style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <input
                            type="file"
                            id="img_photoId"
                            name="img"
                            onChange={handlePhotoChange}
                            className="hidden"
                            accept="image/*"
                        />

                        <img
                            src={imgFile}
                            alt="img"
                            onClick={() => handlePhotoClick()}
                            height="160"
                            width="160"
                            style={{ width: 160, border: "1px solid #ddd", display: "block" }}
                            onError={onError}
                        />

                    </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove" style={{marginTop:"20px"}}>
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                                <label className="control-label text-left col-md-12 col-sm-12 col-xs-12 " htmlFor="name">
                                    Father Name: {fatherName}
                                </label>
                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                                <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                                    <input
                                        className="form-control"
                                        name="Father education"
                                        placeholder="Education"
                                        value={fatherEducation}
                                        onChange={(e) => setFatherEducation(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                                <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                                    <input
                                        className="form-control"
                                        name="Father occupation"
                                        placeholder="Occupation"
                                        value={fatherOccupation}
                                        onChange={(e) => setFatherOccupation(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                                <label className="control-label col-md-12 col-sm-12 col-xs-12 " htmlFor="name">
                                    Mother Name: {motherName}
                                </label>
                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                                <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                                    <input
                                        className="form-control"
                                        name="Mother education"
                                        placeholder="Education"
                                        value={motherEducation}
                                        onChange={(e) => setMotherEducation(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                                <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                                    <input
                                        className="form-control"
                                        name="Mother occupation"
                                        placeholder="Occupation"
                                        value={motherOccupation}
                                        onChange={(e) => setMotherOccupation(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove" >
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <label className="control-label col-md-12 col-sm-12 col-xs-12 " htmlFor="name">
                            Siblings
                        </label>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                            <input
                                type="number"
                                className="form-control"
                                name="No. of Siblings"
                                placeholder="How many ? (excluding you)"
                                value={siblingCount}
                                onChange={(e) => setSiblingCount(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                            <input
                                className="form-control"
                                name="Siblings age"
                                placeholder="Age (, seperated if multiple)"
                                value={siblingsAge}
                                onChange={(e) => setSiblingsAge(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove" >
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <label className="control-label col-md-12 col-sm-12 col-xs-12 " htmlFor="name">
                            Mother Tongue
                        </label>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <div className="form-group col-md-12 col-sm-12 col-xs-12 ">
                            <input
                                className="form-control"
                                name="Mother tongue"
                                placeholder="mother tongue"
                                value={motherTongue}
                                onChange={(e) => setMotherTongue(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" >
                <div className="col-md-6 col-sm-6 col-xs-12 pull-right padding-remove">
                    <div className="form-group col-md-9 col-sm-9 col-sm-10">
                        <button
                            className="pull-right btn btn-info"
                            onClick={(e) => saveStudentDetails(e)}
                            title="Save"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ParentDtls;